export default {
  test_drives: [],
  test_drive_units: [],
  test_drive: null,
  statuses: [],
  actions: [],
  models: [],
  dealers: [],
};
